// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Link} from 'react-router-dom';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {get_article_date, i_article} from '../../../../hola/pub/ui/blog/i_blog';
import styles from './article_card.module.less';

export const Article_card = (props: i_article)=>{
    const {theme} = useContext(Settings_context);
    const art_href = `/blog/${props.categories[0].slug}/${props.slug}`;
    return <Link className={cn(styles.article)} to={art_href}
      key={props.slug}>
      <div className={cn(styles.article_preview, 'lazyload')}
        data-bg={props.preview_image || props.img ||
          undefined}
        style={props.preview_bg ?
          {backgroundColor: props.preview_bg} : {}}></div>
      <div className={styles.article_description}>
        <div className={cn(styles.article_date, theme.u3, theme.reg)}>
          {get_article_date(props)}
        </div>
        <div className={cn(styles.article_text, theme.p2, theme.med)}
          dangerouslySetInnerHTML={{__html: props.title}}/>
        <p className={cn(theme.p4, theme.med, styles.article_bot)}>
          {props.categories.map(one_cat=>{
              return <span key={one_cat.id}>
                  {one_cat.name}{' '}
              </span>;
          })} {'\u00B7'} {props.time_to_read ?
            `${props.time_to_read} read` : ''}
        </p>
      </div>
    </Link>;
};
